import { render, staticRenderFns } from "./epb-insights-bar.component.vue?vue&type=template&id=8a70c4c0&scoped=true"
import script from "./epb-insights-bar.component.vue?vue&type=script&lang=ts"
export * from "./epb-insights-bar.component.vue?vue&type=script&lang=ts"
import style0 from "./epb-insights-bar.component.vue?vue&type=style&index=0&id=8a70c4c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a70c4c0",
  null
  
)

export default component.exports